import "./search.css";
import { useState } from "react";
import { FaQuestionCircle } from "react-icons/fa";

const SearchBadge = ({ icon, text, isActive, clickHandler }) => {

    const [displayIcon, setDisplayIcon] = useState(icon? icon : <FaQuestionCircle />)
    const iconSize = 20;

    return (
        <div 
            onClick={() => clickHandler && clickHandler(text)}
            className={`search-category ${isActive && 'bg-energo'}`}
        >
            <span style={{fontSize: iconSize}}>{displayIcon}</span>
            <span>{text}</span>
        </div>
    )
}
export default SearchBadge;